<template>
  <div :class="box_class" class="d-box" style="display: block" ref="infoBox">
    <MyContent/>
  </div>
</template>

<script>
// @ is an alias to /src
import { MyContent } from '@/components'
import { mapGetters } from 'vuex'
export default {
  name: 'home',
  components: {
    MyContent
  },
  data () {
    return {
      box_h: 0,
      box_class: 'd-box-centered',
    }
  },
  mounted() {
    this.dboxClass()
  },
  methods: {
    dboxClass() {
      this.box_h = this.$refs.infoBox.clientHeight
      if (this.box_h >= (this.window_h - 200)) {
        this.box_class = 'd-box-normal'
      }else {
        this.box_class = 'd-box-centered'
      }
    },
  },
  computed: {
    ...mapGetters([
      'getData'
    ]),
    window_h () {
      return this.getData('window_h')
    },
    progress () {
      return this.getData('progress')
    },
  },
  watch: {
    progress(val) {
      this.dboxClass()
    },
  }
}
</script>
